import { loadUIPreferences } from "./useLocalStorageSync";
import { DEFAULT_METRICS_COLLAPSED } from "components/reportsV3/types/constants";
import { useCallback, useEffect, useState } from "react";

export const useViewMode = ({ reportName, fullscreenContainerRef }) => {
  const [viewMode, setViewMode] = useState("fullpage");

  const [metricsCollapsed, setMetricsCollapsed] = useState(() => {
    const uiPrefs = loadUIPreferences(reportName);
    return uiPrefs?.metricsCollapsed ?? DEFAULT_METRICS_COLLAPSED;
  });

  const expanded = viewMode === "fullpage" || viewMode === "fullscreen";

  const handleToggleMetricsCollapsed = useCallback(() => {
    setMetricsCollapsed((prev) => !prev);
  }, []);

  const handleViewModeChange = useCallback(
    async (_event, newMode) => {
      if (newMode === null) return;

      if (newMode === "fullscreen") {
        if (!fullscreenContainerRef.current) return;
        try {
          await fullscreenContainerRef.current.requestFullscreen();
          setViewMode("fullscreen");
        } catch {}
      } else if (viewMode === "fullscreen") {
        try {
          if (document.fullscreenElement) {
            await document.exitFullscreen();
          }
          setViewMode(newMode);
        } catch {
          setViewMode(newMode);
        }
      } else {
        setViewMode(newMode);
      }
    },
    [viewMode, fullscreenContainerRef]
  );

  useEffect(() => {
    const handleFullscreenChange = () => {
      const inFullscreen = !!document.fullscreenElement;
      if (!inFullscreen && viewMode === "fullscreen") {
        setViewMode("inpage");
      }
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [viewMode]);

  useEffect(() => {
    document.body.style.overflow =
      viewMode === "fullscreen" ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [expanded, viewMode]);
  return {
    viewMode,
    metricsCollapsed,
    setMetricsCollapsed,
    expanded,
    handleViewModeChange,
    handleToggleMetricsCollapsed,
  };
};
export default useViewMode;
